export default __webpack_public_path__ + "static/media/similacMum900.e706f6ee.jpg";